export default "__VITE_ASSET__f300582d__"